import fromEntries from 'object.fromentries';
import appConfig from 'src/utils/appConfig';

const VERIFIED = 'verified';
const USE_AB_TESTER = 'useABTester';
const RETURN_TO_URL = 'return_to';

const BABBEL_URL_REGEX = /https?:\/\/([a-z0-9]+\.)?(babbel)\.(com|cn|io).*/i;

export const getRawQueryString = () => window.location.search;

const qsToObject = () => fromEntries(new URLSearchParams(getRawQueryString()));

export const getQueryStringParams = (overrideParams = {}) =>
  Object.assign({},
    qsToObject(),
    overrideParams
  );

export const getQueryString = (overrideParams = {}) => {
  const queryString = new URLSearchParams(getQueryStringParams(overrideParams));
  return queryString.toString() ? `?${queryString.toString()}` : '';
};

export const getQueryStringWithoutVerifiedParam = (overrideParams = {}) => {
  const queryString = new URLSearchParams(getQueryStringParams(overrideParams));
  queryString.delete([VERIFIED]);
  return queryString.toString() ? `?${queryString.toString()}` : '';
};

export const isUserVerified = () =>
  getQueryStringParams()[VERIFIED] === 'true';

export const shouldAbTesterBeUsed = () =>
  getQueryStringParams()[USE_AB_TESTER] !== 'false';

const getValidDomain = () => {
  return appConfig.getEnvironment() === 'production' ? '.com' : '.cn';
};

export const isValidReturnToURLDomain = (returnToURL) => {
  return returnToURL.match(getValidDomain());
};

// The return_to parameter must be provided as an encoded URI component to avoid mixing query params
export const getReturnToURLFromParams = () => {
  const returnToURL = decodeURIComponent(getQueryStringParams()[RETURN_TO_URL]);
  return BABBEL_URL_REGEX.test(returnToURL) && isValidReturnToURLDomain(returnToURL) ? returnToURL : null;
};
